export const DRAWERS = {
    ATTRIBUTION: 'attributionDrawer',
    FILTER: 'filterDrawer',
    TOOL: 'toolDrawer',
};
